import { resolvePublicationPreferences } from "../publications/preferences.js";

export function consentPresentation(publication) {
  return {
    // Use the publication language itself: editorial locale formatting currently
    // supports fewer languages and must not turn a French consent UI into English.
    locale: /^fr(?:-|$)/i.test(publication?.defaultLanguage || "") ? "fr" : "en",
    fontFamily: resolvePublicationPreferences(publication).fontCss
  };
}

export function consentCopy(locale = "en") {
  if (/^fr(?:-|$)/i.test(locale)) return {
    heading: "Votre vie privée compte",
    body: name => `${name} utilise des cookies facultatifs et des technologies similaires pour améliorer votre expérience, comprendre son lectorat et soutenir la publicité. Nous respectons vos droits en matière de vie privée conformément aux lois applicables, notamment le règlement général sur la protection des données (RGPD) de l’Union européenne et les exigences britanniques en matière de protection des données. Vous pouvez accepter, refuser ou gérer vos préférences à tout moment.`,
    accept: "Tout accepter", reject: "Refuser les cookies facultatifs", manage: "Gérer les préférences",
    privacy: "Politique de confidentialité", cookies: "Politique relative aux cookies",
    title: "Préférences de confidentialité", save: "Enregistrer les préférences", close: "Fermer",
    revisit: "Choix de confidentialité", error: "Impossible d’enregistrer vos préférences. Vérifiez les paramètres des cookies de votre navigateur et réessayez.",
    intro: "Choisissez les catégories facultatives autorisées. Les fonctionnalités nécessaires restent actives. Vous pouvez retirer votre consentement à tout moment.",
    categories: {
      NECESSARY: ["Nécessaires", "Sécurité, accès et fonctionnement essentiel du site. Toujours actifs."],
      FUNCTIONAL: ["Fonctionnels", "Fonctionnalités facultatives et services améliorant votre expérience."],
      ANALYTICS: ["Mesure d’audience", "Comprendre la fréquentation et l’utilisation du site."],
      ADVERTISING: ["Publicité", "Stockage et demandes publicitaires soumis à votre consentement."],
      PERSONALIZATION: ["Personnalisation", "Expériences personnalisées, y compris la publicité lorsque celle-ci est autorisée."]
    }
  };
  return {
    heading: "Your privacy matters",
    body: name => `${name} uses optional cookies and similar technologies to improve your experience, understand readership and support advertising. We respect your privacy rights under applicable laws, including the EU General Data Protection Regulation (GDPR) and UK data protection requirements. You can accept, reject or manage your preferences at any time.`,
    accept: "Accept all", reject: "Reject optional", manage: "Manage preferences",
    privacy: "Privacy Policy", cookies: "Cookie Policy", title: "Privacy preferences",
    save: "Save preferences", close: "Close", revisit: "Privacy choices",
    error: "Your preferences could not be saved. Check your browser cookie settings and try again.",
    intro: "Choose which optional categories to allow. Necessary features remain active. You can withdraw consent at any time.",
    categories: {
      NECESSARY: ["Necessary", "Security, access and essential site operation. Always active."],
      FUNCTIONAL: ["Functional", "Optional features and services that improve your experience."],
      ANALYTICS: ["Analytics", "Understanding readership and how the site is used."],
      ADVERTISING: ["Advertising", "Advertising storage and requests that depend on your consent."],
      PERSONALIZATION: ["Personalization", "Personalized experiences, including advertising when separately permitted."]
    }
  };
}
